<template>
    <v-app-bar
            v-if="items.length > 0"
            class="plan-mobile-menu"
            height="50"
            app
            elevation="0"
    >
        <v-bottom-navigation
                color="primary"
                grow
                height="50"
        >
            <v-btn
                    v-for="(item, key) in items"
                    :key="key"
                    :to="item.to"
                    @click="click(item.event)"
                    :class="{
                        'v-btn--active': item.event !== undefined ? getRoute === item.event : false
                    }"
                    elevation="0"
            >
                <span>{{ $t(item.text) }}</span>
                <badge-count
                    v-if="item.to !== null && item.to.name === 'curator'"
                    :count="$store.state.chat.unreadMessages"
                ></badge-count>
            </v-btn>
        </v-bottom-navigation>
    </v-app-bar>
</template>

<script>
    import BadgeCount from "../ui/BadgeCount";

    export default {
        components: {BadgeCount},
        data() {
            return {};
        },
        computed: {
            items() {
                let items = [];

                let diary = ['diary', 'week', 'month'];
                if (diary.indexOf(this.$route.name) > -1) {
                    items = items.concat([
                        {text: 'msg.Day', to: {name: 'diary'}, click: null, active: false, event: 'diary.day'},
                        {text: 'msg.week', to: {name: 'week'}, click: null, active: false, event: 'diary.week'},
                        {text: 'msg.month', to: {name: 'month'}, click: null, active: false, event: 'diary.month'}
                    ]);
                }
              
                let plan = ['projects', 'create_project', 'edit_project', 'tasks', 'tasks_report',
                  'notes', 'create_note', 'note'];
                if (plan.indexOf(this.$route.name) > -1) {
                    items = items.concat([
                        {text: 'msg.projects', to: {name: 'projects'}, click: null},
                        {text: 'msg.notes', to: {name: 'notes'}, click: null}
                    ]);
                }

                let target = ['targets', 'feed', 'targets_diary'];
                if (target.indexOf(this.$route.name) > -1) {
                  items = items.concat([
                    {text: 'msg.my', to: {name: 'targets'}, click: null},
                    {text: 'msg.feed', to: {name: 'feed'}, click: null}
                  ]);
                }

                let finance = ['transactions', 'transfer', 'edit_transfer', 'create_transaction', 'edit_transaction',
                    'accounts', 'create_account', 'edit_account', 'groups', 'create_group', 'edit_group', 'month_budget'];
                if (finance.indexOf(this.$route.name) > -1) {
                    items = items.concat([
                        {text: 'msg.transactions', to: {name: 'transactions'}, click: null},
                        {text: 'msg.accounts', to: {name: 'accounts'}, click: null},
                        {text: 'msg.groups', to: {name: 'groups'}, click: null}
                    ]);
                }

                // let other = ['feed', 'curator', 'profile'];
                // if (other.indexOf(this.$route.name) > -1) {
                //     items = items.concat([
                //         {text: 'msg.feed', to: {name: 'feed'}, click: null},
                //         {text: 'msg.curator', to: {name: 'curator'}, click: null},
                //         {text: 'msg.profile', to: {name: 'profile'}, click: null}
                //     ]);
                // }

                return items;
            },
            getRoute() {
                return this.$store.state.common.extraMobileMenu;
            }
        },
        methods: {
            click(event) {
                if (event === undefined) return;
                this.$store.commit('changeExtraMobileMenu', event);
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/vars';

    .plan-mobile-menu {
        .v-btn {
            font-weight: 400;
            letter-spacing: normal;
            font-size: 12px !important;
        }
        .v-btn--active {
            background: $colorPrimaryLight !important;
        }
        .v-toolbar__content {
            padding: 0;
        }
    }
</style>